// Generated by CoffeeScript 1.9.1
var MenuBuilder, SelectionMenu;
MenuBuilder = require("../menubuilder");
module.exports = SelectionMenu = MenuBuilder.extend({
  initialize: function initialize(data) {
    this.g = data.g;
    return this.el.style.display = "inline-block";
  },
  render: function render() {
    this.setName("Selection");
    this.addNode("Find Motif (supports RegEx)", function (_this) {
      return function () {
        var search;
        search = prompt("your search", "D");
        return _this.g.user.set("searchText", search);
      };
    }(this));
    this.addNode("Invert columns", function (_this) {
      return function () {
        var i, ref, results;
        return _this.g.selcol.invertCol(function () {
          results = [];
          for (var i = 0, ref = _this.model.getMaxLength(); 0 <= ref ? i <= ref : i >= ref; 0 <= ref ? i++ : i--) {
            results.push(i);
          }
          return results;
        }.apply(this));
      };
    }(this));
    this.addNode("Invert rows", function (_this) {
      return function () {
        return _this.g.selcol.invertRow(_this.model.pluck("id"));
      };
    }(this));
    this.addNode("Reset", function (_this) {
      return function () {
        return _this.g.selcol.reset();
      };
    }(this));
    this.el.appendChild(this.buildDOM());
    return this;
  }
});